export default __webpack_public_path__ + "static/media/Zahl-3.81ec33a0.png";